import { Store } from "redux";
import {
  pickOnBoardingSubTitle,
  pickOnBoardingTitle
} from "../../../Home/actions/onBoardingUI";

export let _OB_TITLE: string = "";
export let _OB_SUBTITLE: string = "";

export function setOBTitle(title: string): void {
  const store = window["_GLOBAL_REDUX_STORE"] as Store<any>;
  _OB_TITLE = title;

  if (store) {
    store.dispatch(pickOnBoardingTitle(title));
  }
}

export function setOBSubTitle(subTitle: string): void {
  const store = window["_GLOBAL_REDUX_STORE"] as Store<any>;
  _OB_SUBTITLE = subTitle;

  if (store) {
    store.dispatch(pickOnBoardingSubTitle(subTitle));
  }
}
